import React from 'react';
import { CONTENT_REVIEWED_ISO } from '../../compliance/mtdFacts';

/**
 * Returns the real content-reviewed ISO date from the compliance registry.
 * Used by schema.org dateModified fields across tool components.
 */
export const getFreshnessDateIso = () => CONTENT_REVIEWED_ISO;

const FreshnessDate = ({ className = "" }) => {
  const reviewed = new Date(CONTENT_REVIEWED_ISO);
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  return (
    <div className={`text-xs font-semibold text-slate-500 uppercase flex items-center gap-2 ${className}`}>
      <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
      Content reviewed: {monthNames[reviewed.getMonth()]} {reviewed.getFullYear()}
    </div>
  );
};

export default FreshnessDate;
